module.exports = __webpack_public_path__ + "static/media/whitewater.a3cf53b8.gif";